import { AxiosResponse } from 'axios';
import $api from './instance';
import type { GetTenantsTable } from '../types/responses';

export async function getTenantsRequest(): Promise<GetTenantsTable> {
  const res = await $api.get('/tenants');
  return res.data;
}

export async function getAllTenantsRequest(status: string): Promise<AxiosResponse<any[]>> {
  return $api.get(`/tenants/all?status=${status}`);
}

export async function searchTenantsRequest(
  query: string,
  status: string,
): Promise<AxiosResponse<any[]>> {
  return $api.get(`/tenants/search?q=${query}&status=${status}`);
}

export async function getTenantByIdRequest(
  tenantId: number | string,
): Promise<AxiosResponse<any>> {
  return $api.get(`/tenants/${tenantId}`);
}

/**
 * @deprecated Застаріла логіка tenant
 */
export async function deleteTenantRequest(
  propertyId: number,
  tenantId: number,
) {
  return $api.delete(`/properties/${propertyId}/tenants/${tenantId}`);
}
